const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: { width: '30px', height: '30px', borderWidth: '3px' },
    medium: { width: '50px', height: '50px', borderWidth: '4px' },
    large: { width: '70px', height: '70px', borderWidth: '5px' }
  };

  const spinnerStyle = {
    display: 'inline-block',
    ...sizeClasses[size],
    border: `${sizeClasses[size].borderWidth} solid #e2e8f0`,
    borderTopColor: '#667eea',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '2rem',
      minHeight: '200px'
    }}>
      <div style={spinnerStyle}></div>
      {text && <p style={{ marginTop: '1rem', color: '#6c757d' }}>{text}</p>}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
